<template>
<div :class="{ 'pt-8': isWhiteGloveUser }" class="d-flex flex-column" style="flex: 1;">

  <!-- NOTE: Backlinks feedback bar hidden. Remove "false" from the condition below to unhide -->
  <div v-if="false && !feedbackGiven && !$store.state.isLoading" class="hero-body my-6">
    <FeedbackBar />
  </div>

  <div
    v-if="isWhiteGloveUser"
    class="sites-wg-header ml20 mr20 mt10">
    <div class="sites-wg-header__top-row">
      <div class="dashboard-name sites-wg-header__title">All projects</div>
      <div class="sites-wg-header__top-row-end">
        <div class="grid-sort-filter-block sites-wg-header__filters">
          <span v-if="sites.length">
            <span class="">Sort by</span>
            <div>
              <select @change="e => { $store.commit('setSortModeSites', e.target.value); }">
                <option
                  value="recent"
                  :selected="$store.state.sortModeSite == 'recent'"
                  >Most recent project
                </option>
                <option
                  value="recent_report"
                  :selected="
                    $store.state.sortModeSite == 'recent_report'
                  "
                  >Most recent report</option
                >
                <option
                  value="oldest_report"
                  :selected="
                    $store.state.sortModeSite == 'oldest_report'
                  "
                  >Oldest report</option
                >
                <option
                  value="alphabetic"
                  :selected="
                    $store.state.sortModeSite == 'alphabetic'
                  "
                  >Alphabetic</option
                >
                <option
                  value="best_score"
                  :selected="
                    $store.state.sortModeSite == 'best_score'
                  "
                  >Best score</option
                >
                <option
                  value="worst_score"
                  :selected="
                    $store.state.sortModeSite == 'worst_score'
                  "
                  >Worst score</option
                >
              </select>
            </div>
          </span>
    
          <span v-if="user.ownerAccounts && user.ownerAccounts.length > 0">
            <span>Account</span>
            <select
              v-model="selectedSubAccountRelation"
              style="width: 200px"
            >
              <option selected disabled
                >Please select one account</option
              >
              <option value="">My account</option>
              <option disabled> ---------- </option>
              <option disabled>
                Accounts you have access to:
              </option>
              <option
                :value="relation"
                v-for="relation in ownerAccountsAlphabeticSort(user.ownerAccounts)"
                :key="relation.id"
              >
                {{ relation.agencyName }}
                ( Permission:
                {{
                  relation.isAllPermission
                    ? "All Projects"
                    : relation.permittedProjects.length == 1
                    ? relation.permittedProjects.length + " Project"
                    : +relation.permittedProjects.length +
                      " Projects"
                }}, Create Project:
                {{ relation.canCreateProject ? "YES" : "NO" }} )
              </option>
            </select>
          </span>
    
          <span v-if="user.ownerDevAccounts && user.ownerDevAccounts.length > 0">
            <span>Dev access</span>
            <select
              v-model="selectedDevAccountRelation"
              style="width: 200px"
            >
              <option selected disabled
                >Please select one account</option
              >
              <option value="">My account</option>
              <option disabled> ---------- </option>
              <option disabled>
                Accounts you have access to as dev:
              </option>
              <option
                :value="relation"
                v-for="relation in ownerAccountsAlphabeticSort(user.ownerDevAccounts)"
                :key="relation.id"
              >
                {{ relation.ownerUserEmail }}
              </option>
            </select>
          </span>
        </div>
        <white-glove-admin-mode-toggle />
      </div>
    </div>
  </div>
  <div v-else class="ml20 mr20 dashboard-name">
    All projects
  </div>
  <div class="hero-body" v-if="user.accountType == 'sub_account' && !selectedOwnerAccount">
    <div class="columns">
      <div class="column is-offset-2 is-8">

        <div class="columns" >
          <div class="column">
            <p style="margin-top: 50px;"
              class='has-text-centered subtitle'>
              You are in your own account and do not have an active POP subscription. <br/>
              To view your assigned projects or create projects in another account that you have been given access to, click manage account and switch accounts in the account management dashboard.
            </p>
          </div>
        </div>

        <div class="columns" >
          <div class="column">
            <p style="margin-top: 50px;"
              class='has-text-centered body-font is-size-4 mainColor--text'>
              
            </p>
            <p v-if="user.isTrial">During your trial period you cannot use a domain that you or someone else has previously used.</p>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div v-else-if="!$store.state.isLoading && !sites.length">
    <div v-if="!user.isVendor" class="empty-project">
      <img class="no-page-img" src="/static/no-page.png" />
      <div class="title-label">
        You don’t have any projects yet
        <span class="material-icons video-tutorial-icon video-tutorial-icon-size"
          @click="() => {
            $store.commit('setCurrentVideoTutorialToDisplay', {
              title: 'How to Set Up a New Project in POP',
              videoLink: 'https://www.youtube.com/embed/z_Mu-86IFfc?si=DUb4xYaDKwu4RR2V',
              description: 'Learn how to set up a new project in POP.',
              time: '2m 23s'
            });
          }">
          videocam
        </span>
      </div>
      <div class="explain">
        Looks like you're just getting started!  Click the orange New project button above, the New project text in the left side bar, or the button below to create your first project.
        <br/>
      </div>
      <v-btn rounded outlined
        color="grayColor"
        class="button-with-icon text-none mt20 gray2Color--text"
        @click="addSite"
        >
        <i class="material-icons font-weight-bold">add</i>
        <span class="font-weight-bold">Add new project</span>
      </v-btn>
    </div>
  </div>
  
  <section class="d-flex flex-column" style="flex: 1; justify-content: space-between; gap: 30px;">
    <div class="pl20 pr20 mt-5" ref="observer">
      <div
        v-if="selectedSiteIds.length > 0"
        class="sites-selection-bar">
        <button
          type="button"
          class="sites-selection-bar__close"
          aria-label="Clear selection"
          @click.stop="cancelAllSelection">
          <i class="material-icons sites-selection-bar__close-icon" aria-hidden="true">close</i>
        </button>
        <div class="sites-selection-bar__inner d-flex align-center">
          <div class="sites-selection-bar__selection d-flex align-center">
            <button
              type="button"
              class="sites-selection-bar__checkbox"
              aria-label="Clear selection"
              @click.stop="cancelAllSelection">
              <i class="material-icons sites-selection-bar__check-icon" aria-hidden="true">check</i>
            </button>
            <span class="sites-selection-bar__count">
              {{ selectedSiteIds.length }} Selected project{{
                selectedSiteIds.length === 1 ? '' : 's'
              }}
            </span>
          </div>
          <div class="sites-selection-bar__actions d-flex align-center">
            <v-btn
              rounded
              outlined
              depressed
              :disabled="!canPinAllSelected"
              class="sites-selection-bar__btn sites-selection-bar__btn--outline text-none"
              @click.stop="pinAllSelected">
              Pin all
            </v-btn>
            <v-btn
              rounded
              depressed
              class="sites-selection-bar__btn sites-selection-bar__btn--fill text-none"
              @click.stop="showDeleteSitesConfirmModal = true">
              Delete all
            </v-btn>
          </div>
        </div>
      </div>

      <sites-filter-white-glove
        v-if="isWhiteGloveUser && sites.length"
        v-model="wgSiteFilter"
        :counts="wgTabCounts"
      />

      <p
        v-if="isWhiteGloveUser && sites.length && wgFilteredSites.length === 0"
        class="gray2Color--text mt-4 mb-0">
        No projects match this filter.
      </p>

      <div class='sites-or-pages-container mt-6' ref="sitesContainer">
        <template v-for='site in paginatedSites'>
          <site-card-white-glove
            v-if='isWhiteGloveUser'
            :key='`wg-${site.id}`'
            :site='site'
            :insight="wgCardInsight(site.id)"
            :isSelected='isSelectedSite(site.id)'
            :isDemo='isDemo'
            :createdAt='getDateAsLocalString(site.createdAt)'
            @select='selectSite'
            @unselect='unSelectSite'
            @pin='({ siteId, isPinned }) => pinProjectAction(siteId, isPinned)'
            @open-settings='enterProjectSetting'
            @delete='displayDeleteSiteConfirmationDlg'
          />
          <site-card
            v-else
            :key='site.id'
            :site='site'
            :isSelected='isSelectedSite(site.id)'
            :isDemo='isDemo'
            :createdAt='getDateAsLocalString(site.createdAt)'
            @select='selectSite'
            @unselect='unSelectSite'
            @pin='({ siteId, isPinned }) => pinProjectAction(siteId, isPinned)'
            @open-settings='enterProjectSetting'
            @delete='displayDeleteSiteConfirmationDlg'
          />
        </template>
      </div>
    </div>
    <paginate
      v-if="pageCount > 1"
      :value="currentPageForSite"
      :page-count="pageCount"
      prev-text="<i class='material-icons'>navigate_before</i>"
      next-text="<i class='material-icons'>navigate_next</i>"
      container-class="card-pagination"
      :click-handler="paginateFunc">
    </paginate>
  </section>

  <div class="modal" :class="{'is-active': showDeleteConfirmModal}">
    <div class="modal-background" @click="showDeleteConfirmModal = false"></div>
    <div class="modal-content">
      <div class="box modal-container" style="overflow: hidden;">
        <div class="modal-content-root">
          <div class="title-font is-size-4 mainColor--text">You’re about to delete this project.</div>
          <div class="mt-5 mainColor--text">
            Are you sure you want to delete this project? <br/>
            <span v-if="user.accountType === 'trial'">On a free trial if you delete this project you won't be able to use this domain again.</span>
          </div>
          <div class="control flex mt20">
            <div class="flex-grow-1">
            </div>
            <v-btn rounded outlined
              color="mainColor"
              class="button-with-icon mainColor--text text-none"
              @click="showDeleteConfirmModal=false">
              <span>Cancel</span>
            </v-btn>
            <v-btn rounded
              color="profileAnchorColor"
              class="button-with-icon text-none whiteColor--text" @click="deleteSite">
              <i class="fa fa-trash mr5"></i>
              <span>Delete</span>
            </v-btn>
          </div>
        </div>
      </div>
      <button class="custom-modal-close-btn" aria-label="close" @click="showDeleteConfirmModal = false"><i class="material-icons">close</i></button>
    </div>
  </div>


  <div class="modal" :class="{'is-active': showNoPermissionToCreateProject}">
    <div class="modal-background" @click="showNoPermissionToCreateProject = false"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <p class="title"></p>
        <p class="subtitle">
          {{ (user.accountType == 'sub_account' && $store.state.selectedSubAccountRelation=='') ? 'You currently have access to PageOptimizer Pro through a Sub Account.  You must purchase your own subscription to create projects in your own account.' : 'You don\'t have access to create a project in this Primary Account.  Please contact the account owner to give you permission.' }}
        </p>
        <div class="field has-addons">
          <div class="control">
            <button class="button is-warning" @click="showNoPermissionToCreateProject = false">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <project-setting-modal ref="projectSettingModal" />


  <div class="modal" :class="{'is-active': showDeleteSitesConfirmModal}">
    <div class="modal-background" @click="showDeleteSitesConfirmModal = false"></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="modal-content-root">
          <div class="subtitle-font mainColor--text">
            Are you sure you want to delete these Projects and all their Pages and Reports? <br/>
          </div>
          <div class="mt-3 mb-3 mainColor--text">
            The following projects have been selected:
          </div>
          <div v-for="site in selectedSites" :key="site.id" style="max-height: 400px; overflow-y: auto;">
            <span class="has-text-weight-bold mainColor--text">- {{ site.name }}</span>
            <span class="ml-2 mainColor--text">{{ getDateAsLocalString(site.createdAt) }}</span>
          </div>
          <div class="control flex mt20">
            <div class="flex-grow-1">
            </div>
            <v-btn rounded color="grayColor"
              class="button-with-icon text-none gray2Color--text"
              @click="showDeleteSitesConfirmModal=false">
              <i class="fa fa-times mr5"></i>
              <span>Cancel</span>
            </v-btn>
            <v-btn rounded color="lightGreenColor"
              class="button-with-icon text-none whiteColor--text" @click="deleteSites">
              <i class="fa fa-trash mr5"></i>
              <span>Delete</span>
            </v-btn>
          </div>
        </div>
      </div>
      <button class="custom-modal-close-btn" aria-label="close" @click="showDeleteSitesConfirmModal = false"><i class="material-icons">close</i></button>
    </div>
  </div>

</div>
</template>

<script>
import moment from 'moment'
import RadialProgressBar from 'vue-radial-progress'
import AppMenu from '@/components/Menu.vue'
import ProjectSettingModal from '@/components/ProjectSettingModal.vue'
import { mixin } from '@/components/mixin'
import { mixin as ServiceMixin } from '@/components/service_mixin'
import Paginate from 'vuejs-paginate'
import FeedbackBar from "@/common/FeedbackBar/FeedbackBar.vue";
import { whiteGlovePlans } from "@/components/plans_constants"
import { getPureServicePkgName } from '@/utils'
import {
  countSitesByWhiteGloveTag,
  getWhiteGloveSiteCardInsight,
  getWhiteGloveSiteTags,
  parseWhiteGloveOrdersResponse,
} from '@/utils/whiteGloveSiteList'
import SiteCard from '@/components/SitesListView/SiteCard.vue'
import SiteCardWhiteGlove from '@/components/SitesListView/SiteCardWhiteGlove.vue'
import SitesFilterWhiteGlove from '@/components/SitesListView/SitesFilterWhiteGlove.vue'
import WhiteGloveAdminModeToggle from '@/components/SitesSingleView/WhiteGlove/WhiteGloveAdminModeToggle.vue'

const WG_WIDE_VIEWPORT_MIN_WIDTH = 2000
// Minimum grid track width; must match $site-card-width and gap in .sites-or-pages-container (main.scss)
const WG_GRID_TRACK_PX = 345
const WG_GRID_GAP_PX = 15
const WG_WIDE_VIEWPORT_ROW_COUNT = 5

import { planGateMixin } from '@/components/Auth/plan-gate'
export default {
  components: {
    FeedbackBar,
    RadialProgressBar,
    AppMenu, ProjectSettingModal,
    Paginate,
    SiteCard,
    SiteCardWhiteGlove,
    SitesFilterWhiteGlove,
    WhiteGloveAdminModeToggle,
  },
  mixins: [ mixin, ServiceMixin, planGateMixin ],
  data () {
    return {
      feedbackGiven: false,
      selectedSiteId: 0,
      showDeleteConfirmModal: false,
      showNoPermissionToCreateProject: false,


      selectedSiteIds: [],
      showDeleteSitesConfirmModal: false,


      wgGridResizeObserver: null,
      wgGridContainerWidth: 0,

      whiteGloveOrders: [],
      whiteGloveSiteProjectStatuses: {},
      wgSiteFilter: 'all',

      selectedSubAccountRelation: '',
      selectedDevAccountRelation: null,

      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
    }
  },
  computed: {
    isDemo () {
      return this.$store.getters.isDemoUser
    },
    _ () {
      return moment
    },
    selectedOwnerAccount () {
      return this.$store.state.selectedSubAccountRelation
    },
    selectedSites () {
      return this.selectedSiteIds.map(siteId => {
        let found = this.sites.find(ele => {
          return ele.id==siteId
        })
        return found
      })
    },
    currentPageForSite () {
      return this.$store.state.currentPageForSite
    },
    wgGridColumnCount () {
      const w = this.wgGridContainerWidth
      if (w <= 0) return 0
      const cell = WG_GRID_TRACK_PX + WG_GRID_GAP_PX
      return Math.max(1, Math.floor((w + WG_GRID_GAP_PX) / cell))
    },
    effectiveSitesPerPage () {
      const base = this.$store.state.sitesPerPage
      if (!this.isWhiteGloveUser || this.windowWidth <= WG_WIDE_VIEWPORT_MIN_WIDTH) {
        return base
      }
      const cols = this.wgGridColumnCount
      if (cols < 1) {
        return base * 2
      }
      return cols * WG_WIDE_VIEWPORT_ROW_COUNT
    },
    wgFilteredSites () {
      if (!this.isWhiteGloveUser) return this.sites
      if (this.wgSiteFilter === 'all') return this.sites
      if (this.wgSiteFilter === 'issues') {
        return this.sites.filter((s) =>
          getWhiteGloveSiteTags(s.id, this.whiteGloveOrders, this.whiteGloveSiteProjectStatuses).has('issues')
        )
      }
      return this.sites.filter((s) =>
        getWhiteGloveSiteTags(s.id, this.whiteGloveOrders, this.whiteGloveSiteProjectStatuses).has(this.wgSiteFilter)
      )
    },
    wgTabCounts () {
      return countSitesByWhiteGloveTag(this.sites, this.whiteGloveOrders, this.whiteGloveSiteProjectStatuses)
    },
    pageCount () {
      const list = this.isWhiteGloveUser ? this.wgFilteredSites : this.sites
      return Math.ceil(list.length / this.effectiveSitesPerPage)
    },
    paginatedSites () {
      const list = this.isWhiteGloveUser ? this.wgFilteredSites : this.sites
      const from = (this.currentPageForSite - 1) * this.effectiveSitesPerPage
      const to = this.currentPageForSite * this.effectiveSitesPerPage
      return list.slice(from, to)
    },
    isWhiteGloveUser () {
      if (!this.user) return false;
      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
    canPinAllSelected () {
      if (this.isDemo) return false
      return this.selectedSiteIds.some((siteId) => {
        const site = this.sites.find((s) => s.id === siteId)
        return site && !site.isPinned
      })
    },
  },
  watch: {
    pageCount (n) {
      if (n >= 1 && this.currentPageForSite > n) {
        this.$store.commit('setCurrentPageForSite', n)
      }
    },
    wgSiteFilter () {
      this.$store.commit('setCurrentPageForSite', 1)
    },
    '$store.state.selectedSubAccountRelation': function (newVal) {
      if (newVal !== this.selectedSubAccountRelation) {
        this.selectedSubAccountRelation = newVal
      }
    },
    selectedSubAccountRelation: function (newVal, oldVal) {
      if (!this.$store.getters.isAuthenticated) {
        return
      }
      if (newVal !== oldVal) {
        if (newVal !== null) {
          this.$store.commit('setCurrentSubAccount', newVal)
          this.$store.commit('setCurrentSiteById', { siteId: -1 })
          this.$store.commit('setCurrentPageById', { pageId: -1 })
          this.loadSitesForAccountChange()
          this.loadWhiteGloveOrdersForDashboard()
          if (newVal.id) {
            localStorage.setItem('lastSelectedSubAccountRelationId', newVal.id)
          } else if (newVal === '') {
            localStorage.setItem('lastSelectedSubAccountRelationId', '')
          }
        } else {
          localStorage.removeItem('lastSelectedSubAccountRelationId')
        }
      }
    },
    selectedDevAccountRelation: function (newVal) {
      if (!this.$store.getters.isAuthenticated) {
        return
      }
      this.$store.commit('setCurrentDevAccount', newVal)
    },
  },
  created () {
    this.selectedSubAccountRelation = this.$store.state.selectedSubAccountRelation
    this.selectedDevAccountRelation = this.$store.state.selectedDevAccountRelation
  },
  methods: {
    wgCardInsight (siteId) {
      return getWhiteGloveSiteCardInsight(siteId, this.whiteGloveOrders, this.whiteGloveSiteProjectStatuses)
    },
    loadSitesForAccountChange () {
      this.$store
        .dispatch('loadSites')
        .then((response) => {
          if (response.data && response.data.status === 'SUCCESS') {
            this.$store.commit('setSites', response.data.sites)
          }
        })
    },
    loadWhiteGloveOrdersForDashboard () {
      const u = this.$store.state.user
      if (!u) {
        this.whiteGloveOrders = []
        this.whiteGloveSiteProjectStatuses = {}
        return Promise.resolve()
      }
      const accountType = this.$store.state.selectedSubAccountRelation
        ? this.$store.state.selectedSubAccountRelation.ownerAccountType
        : u.accountType
      if (!whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        this.whiteGloveOrders = []
        this.whiteGloveSiteProjectStatuses = {}
        return Promise.resolve()
      }
      return this.$store
        .dispatch('getWhiteGloveOrders')
        .then((response) => {
          const parsed = parseWhiteGloveOrdersResponse(response)
          this.whiteGloveOrders = parsed.orders
          this.whiteGloveSiteProjectStatuses = parsed.siteProjectStatuses
        })
        .catch(() => {
          this.whiteGloveOrders = []
          this.whiteGloveSiteProjectStatuses = {}
        })
    },
    ownerAccountsAlphabeticSort (ownerAccounts) {
      return (ownerAccounts || []).toSorted((a, b) => {
        if (a.agencyName.toLowerCase() < b.agencyName.toLowerCase()) {
          return -1
        }
        if (a.agencyName.toLowerCase() > b.agencyName.toLowerCase()) {
          return 1
        }
        return 0
      })
    },
    paginateFunc (pageNumber) {
      this.$store.commit('setCurrentPageForSite', pageNumber)
    },
    onSitesListWindowResize () {
      this.windowWidth = window.innerWidth
    },
    setupWgSitesGridResizeObserver () {
      if (typeof ResizeObserver === 'undefined') return
      const el = this.$refs.sitesContainer
      if (!el) return
      this.teardownWgSitesGridResizeObserver()
      this.wgGridResizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0]
        if (entry && entry.contentRect) {
          this.wgGridContainerWidth = entry.contentRect.width
        }
      })
      this.wgGridResizeObserver.observe(el)
    },
    teardownWgSitesGridResizeObserver () {
      if (this.wgGridResizeObserver) {
        this.wgGridResizeObserver.disconnect()
        this.wgGridResizeObserver = null
      }
    },
    isSelectedSite(siteId) {
      return this.selectedSiteIds.includes(siteId)
    },
    selectSite (siteId) {
      if (this.selectedSiteIds.indexOf(siteId)===-1) {
        this.selectedSiteIds.push(siteId)
      }
    },
    unSelectSite (siteId) {
      let idx = this.selectedSiteIds.indexOf(siteId)
      if (idx>=0) {
        this.selectedSiteIds.splice(idx, 1)
      }
    },
    cancelAllSelection () {
      this.selectedSiteIds = []
    },
    addSite () {
      if (!this.requirePlan(null, 'project')) return
      if (this.hasAbilityOfCreateProject()) {
        this.$router.push('/newsite')
      } else {
        this.showNoPermissionToCreateProject = true
      }
    },
    pageRunCountForSite(site) {
      let total = 0
      site.pages.map(p => total +=p.pageRunCount)
      return total
    },
    displayDeleteSiteConfirmationDlg (siteId) {
      this.selectedSiteId = siteId;
      this.showDeleteConfirmModal = true;
    },
    deleteSite () {
      let siteId = this.selectedSiteId;
      // console.log('user is', this.user.accountType);
      this.showDeleteConfirmModal = false;
      this.$store.commit('showLoading')
      this.$store.dispatch('removeSite', { siteId })
        .then((response) => this.$store.dispatch('loadSites'))
        .then((response) => {
          if (response.data && response.data.status === 'SUCCESS') {
            this.$store.commit('setSites', response.data.sites)
          }
          return 1
        })
        .finally(() => {
          this.$store.commit('hideLoading')
        })
    },
    deleteSites () {
      if (this.selectedSiteIds.length>0) {
        this.$store.commit('showLoading')
        this.$store.dispatch('removeSites', { siteIds: this.selectedSiteIds })
          .then((response) => {
            this.selectedSiteIds = []
            return this.$store.dispatch('loadSites')
          })
          .then((response) => {
            if (response.data && response.data.status === 'SUCCESS') {
              this.$store.commit('setSites', response.data.sites)
              return 1
            }
          })
          .finally(() => {
            this.showDeleteSitesConfirmModal = false
            this.$store.commit('hideLoading')
          })
      }      
    },
    enterProjectSetting (site) {
      this.$refs.projectSettingModal.show(site)       
    },
    pinProjectAction (siteId, isPinned) {
      this.$store.commit('showLoading')
      this.$store.dispatch('saveProjectSettings', {
        siteId,
        changePinOnly: true,
        isPinned: isPinned ? 1 : 0,
      })
      .then((res) => {
        if (res.data && res.data.status=='SUCCESS') {
          this.$store.commit('setSite', res.data.site)
        } else {
          let error = res.data.error ? res.data.error : ''
          window.alert('Can not update project settings.\n' + error)
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading')
      })
    },
    pinAllSelected () {
      if (!this.canPinAllSelected) return
      const siteIds = this.selectedSiteIds.filter((siteId) => {
        const site = this.sites.find((s) => s.id === siteId)
        return site && !site.isPinned
      })
      if (!siteIds.length) return

      this.$store.commit('showLoading')
      const pinNext = (index) => {
        if (index >= siteIds.length) {
          this.$store.commit('hideLoading')
          return
        }
        const siteId = siteIds[index]
        this.$store.dispatch('saveProjectSettings', {
          siteId,
          changePinOnly: true,
          isPinned: 1,
        })
          .then((res) => {
            if (res.data && res.data.status === 'SUCCESS') {
              this.$store.commit('setSite', res.data.site)
              pinNext(index + 1)
            } else {
              const error = res.data && res.data.error ? res.data.error : ''
              window.alert('Can not update project settings.\n' + error)
              this.$store.commit('hideLoading')
            }
          })
          .catch(() => {
            window.alert('Can not update project settings.')
            this.$store.commit('hideLoading')
          })
      }
      pinNext(0)
    },
    // onResize () { // change grid
    //   const element = this.$refs.observer;
    //   const cardWidth = 345;
    //   if (!element) return;
    //   const width = element.clientWidth;
    //   let style = `repeat(4, ${cardWidth}px)`
    //   console.log('width is', width);
      
    //   if ( width < 1460) { // $site-card-width * 4 + 10 (gap) * 3  = 1410 + (50px for extra)
    //     style = `repeat(3, ${cardWidth}px)`
    //   }
    //   if ( width < 1105) { // $site-card-width * 3 + 10 (gap) * 2  = 1055 + (50px for extra)
    //     style = `repeat(2, ${cardWidth}px)`
    //   }
    //   if ( width < 750) { // $site-card-width * 2 + 10 (gap) * 1  = 700 + (50px for extra)
    //     style = `repeat(1, ${cardWidth}px)`
    //   }
    //   if ( width < 350) { // $site-card-width + (5 px extra)
    //     style = `1fr`;
    //   }
    //   console.log('set for element of grid', style);
    //   this.$refs.sitesContainer.style.gridTemplateColumns = style;
    // }
  },
  beforeMount() {
  this.$store.commit('showLoading')
  const sitesPromise = this.$store.dispatch('loadSites')
    .then((response) => {
      if (response.data && response.data.status === 'SUCCESS') {
        this.$store.commit('setSites', response.data.sites)
      }
    })
  const feedbackPromise = this.$store.dispatch('loadFeedbackStatus')
    .then(({ data }) => {
      if (data.feedback_given === true) {
        this.feedbackGiven = true
        this.$store.commit('setFeedbackGiven', true)
      } else {
        this.feedbackGiven = false
        this.$store.commit('setFeedbackGiven', false)
      }
    })
  const wgOrdersPromise = this.loadWhiteGloveOrdersForDashboard()

  Promise.all([sitesPromise, feedbackPromise, wgOrdersPromise])
    .finally(() => this.$store.commit('hideLoading'))
},
  mounted () {
    this.$store.commit('setHideSideBar', this.$store.state.isUserClosedSideBar)
    window.addEventListener('resize', this.onSitesListWindowResize)
    this.$nextTick(() => {
      this.setupWgSitesGridResizeObserver()
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onSitesListWindowResize)
    this.teardownWgSitesGridResizeObserver()
  },
}
</script>

<style lang="scss" scoped>

.delete-site {
  position: relative;
  top: 0px;
  right: -10px;
}

.add-site {
  width: 50%;
  display: inline-block;
  cursor: pointer;
}

.sites {
  margin-top: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.site {
  margin: 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: lightblue;
  color: black;
  width: 30%;
  min-width: 150px;
  min-height: 150px;
  border-radius: 7px;
}

.page-title {
  width: 50%;
  display: inline-block;
}



.hero-body {
  padding: 1rem 1.5rem 0rem 1.5rem !important;
}

.sites-wg-header {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  margin-bottom: 2rem;

  &__top-row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  &__title {
    margin: 0;
    line-height: 1.2;
    flex: 0 1 auto;
    min-width: 0;
  }

  &__top-row-end {
    flex-shrink: 0;
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  &__filters {
    width: 100%;

    select {
      background: transparent;
    }
  }
}

.sites-selection-bar {
  position: fixed;
  right: 30px;
  bottom: 30px;
  left: auto;
  top: auto;
  z-index: 100;
  max-width: calc(100vw - 60px);
  background: #f5f6fa;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px 24px;
  box-sizing: border-box;

  &__close {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: transparent;
    cursor: pointer;
    color: #757575;
    font: inherit;
    appearance: none;
    -webkit-appearance: none;
  }

  &__close:hover {
    color: #003d4c;
  }

  &__close:focus {
    outline: none;
  }

  &__close:focus-visible {
    outline: 2px solid #ff5a00;
    outline-offset: 2px;
  }

  &__close-icon {
    font-size: 18px;
    line-height: 1;
  }

  &__inner {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
  }

  &__selection {
    gap: 12px;
    min-width: 0;
  }

  &__checkbox {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin: 0;
    padding: 0;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;
    cursor: pointer;
    font: inherit;
    color: inherit;
    appearance: none;
    -webkit-appearance: none;
  }

  &__checkbox:hover {
    border-color: #c8c8c8;
    background: #fafafa;
  }

  &__checkbox:focus {
    outline: none;
  }

  &__checkbox:focus-visible {
    outline: 2px solid #ff5a00;
    outline-offset: 2px;
  }

  &__check-icon {
    font-size: 14px;
    line-height: 1;
    color: #003d4c;
  }

  &__count {
    color: #003d4c;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.25;
  }

  &__actions {
    gap: 16px;
    flex-shrink: 0;
    margin-left: auto;
  }

  &__btn {
    font-weight: 700;
    font-size: 14px;
    min-height: 40px !important;
    padding: 0 22px !important;
    letter-spacing: normal;
    box-shadow: none !important;
  }

  &__btn--outline {
    border: 1px solid #ff5a00 !important;
    color: #ff5a00 !important;
    background-color: transparent !important;
  }

  &__btn--fill {
    background-color: #ff5a00 !important;
    color: #fff !important;
    border: 1px solid #ff5a00 !important;
  }

  &__btn--outline:hover::before,
  &__btn--fill:hover::before {
    opacity: 0.08;
  }
}
</style>
